const jobTracking = document.querySelector(".job-tracking");

if (jobTracking) {
	const jobTrackingNewTaskDate = jobTracking.querySelector(".job-tracking__new-task-date");
	const jobTrackingNewTaskProject = jobTracking.querySelector(".job-tracking__new-task-project");
	const jobTrackingNewTaskTime = jobTracking.querySelector(".job-tracking__new-task-time");
	const jobTrackingNewTaskDescription = jobTracking.querySelector(".job-tracking__new-task-description");
	const jobTrackingAddTaskBtn = jobTracking.querySelector(".job-tracking__new-task-add");
	let jobTrackingTbodyDays = jobTracking.querySelectorAll(".job-tracking__day");
	let jobTrackingTimeInputs = jobTracking.querySelectorAll(".job-tracking__time-input");
	const jobTrackingTableSummary = jobTracking.querySelector(".job-tracking__summary");
	const jobTrackingTimeSummary = jobTracking.querySelector(".job-tracking__summary-time");

	const initNewTask = () => {
		jobTrackingNewTaskDate.flatpickr({
			defaultDate: "today",
			dateFormat: "d.m.Y",
		});
		jobTrackingNewTaskTime.value = "";
		jobTrackingNewTaskProject.value = "";
		jobTrackingNewTaskDescription.value = "";
	}

	initNewTask();

	const addTask = (e) => {
		e.preventDefault();
		// get data
		let newTaskDate = jobTrackingNewTaskDate.value;
		let newTaskProject = jobTrackingNewTaskProject.value;
		let newTaskTime = jobTrackingNewTaskTime.value;
		let newTaskDescription = jobTrackingNewTaskDescription.value;

		let jobTrackingTbodyDaysValue = [...jobTrackingTbodyDays].map(tbodyDay => tbodyDay.getAttribute("data-date"));

		// add day tbody
		if (!jobTrackingTbodyDaysValue.includes(newTaskDate)) {
			jobTrackingTableSummary.insertAdjacentHTML('beforebegin',
				`<tbody class="job-tracking__day" data-date=${newTaskDate}>
					<tr class="job-tracking__day-title">
						<td class="cell-content-width">День</td>
						<td><button class="inline-btn job-tracking__day-toggle" type="button"><b>${newTaskDate}</b><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.71892 2.64744C9.6776 1.78419 11.2315 1.78419 12.1901 2.64744L25.2811 14.437C26.2396 15.3003 26.2396 16.6997 25.2811 17.563L12.1901 29.3525C11.2315 30.2158 9.6776 30.2158 8.71892 29.3525C7.76036 28.4892 7.76036 27.0898 8.71892 26.2265L20.0741 16L8.71892 5.77361C7.76036 4.91035 7.76036 3.5107 8.71892 2.64744Z" fill="#002D80"></path></svg></button></td>
						<td></td>
						<td></td>
						<td></td>
						<td class="cell-content-width"></td>
					</tr>
				</tbody>`
			);
		}

		// add task tr
		let jobTrackingTbodyDayForNewTask = jobTracking.querySelector(`.job-tracking__day[data-date="${newTaskDate}"]`);
		jobTrackingTbodyDayForNewTask.insertAdjacentHTML('beforeend',
			`<tr class="job-tracking__task">
				<td class="cell-content-width"></td>
				<td><div class="form-item"><div class="form-item__main"><div class="form-date"><input class="form-input form-date__input form-date__input--simple" type="text" placeholder="Выберите дату" required="required" value="${newTaskDate}"></div></div></div></td>
				<td><div class="form-item"><div class="form-item__main"><div class="form-multi"><div class="form-multi__top"><input class="form-input form-multi__top-input" type="text" placeholder="Выберите проект" readonly="" value="${newTaskProject}"><div class="form-multi__top-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.3526 8.71892C30.2158 9.6776 30.2158 11.2315 29.3526 12.1901L17.563 25.2811C16.6997 26.2396 15.3003 26.2396 14.437 25.2811L2.64746 12.1901C1.78418 11.2315 1.78418 9.6776 2.64746 8.71892C3.51075 7.76036 4.91017 7.76036 5.77345 8.71892L16 20.0741L26.2264 8.71892C27.0896 7.76036 28.4893 7.76036 29.3526 8.71892Z" fill="#001640"></path></svg></div></div><div class="form-multi__choice"><div class="form-multi__search"><input class="form-input form-multi__search-input" type="text" placeholder="Начните вводить"></div><ul class="form-multi__choice-list"><li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="intro-radio-1" id="intro-radio-1_1" value="testintro-radio-1_1"><label class="form-multi__choice-label" for="intro-radio-1_1">Радиокнопка 1</label></li><li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="intro-radio-1" id="intro-radio-1_2" value="testintro-radio-1_2"><label class="form-multi__choice-label" for="intro-radio-1_2">Радиокнопка 2</label></li></ul></div></div></div></div></td>
				<td><div class="form-item"><div class="form-item__main"><div class="form-date"><input class="form-input form-time__input form-time__input--simple job-tracking__time-input" type="text" placeholder="Укажите часы" value="${newTaskTime}"></div></div></div></td>
				<td><div class="form-item"><div class="form-item__main"><textarea class="form-textarea form-textarea--autoheight" placeholder="Коротко о задаче" rows="1">${newTaskDescription}</textarea></div></div></td>
				<td class="cell-content-width"><div class="table__actions"><ul class="table__actions-list"><li class="table__actions-item"><button class="table__actions-btn job-tracking__task-remove" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M13.7903 2C13.2291 2 12.7742 2.46445 12.7742 3.03736V4.07472H7.01613C6.45494 4.07472 6 4.53917 6 5.11209C6 5.685 6.45494 6.14945 7.01613 6.14945H25.9839C26.545 6.14945 27 5.685 27 5.11209C27 4.53917 26.545 4.07472 25.9839 4.07472H20.2258V3.03736C20.2258 2.46445 19.7709 2 19.2097 2H13.7903Z" fill="#002D80"></path><path d="M17.9371 19.6352L19.9281 21.668C20.325 22.0731 20.325 22.7298 19.9281 23.1349C19.5313 23.5401 18.888 23.5401 18.4912 23.1349L16.5 21.1023L14.5088 23.1349C14.112 23.5401 13.4686 23.5401 13.0718 23.1349C12.675 22.7298 12.675 22.0731 13.0718 21.668L15.0629 19.6352L13.0718 17.6023C12.675 17.1972 12.675 16.5405 13.0718 16.1354C13.4686 15.7303 14.112 15.7303 14.5088 16.1354L16.5 18.1681L18.4912 16.1354C18.888 15.7303 19.5313 15.7303 19.9281 16.1354C20.325 16.5405 20.325 17.1972 19.9281 17.6023L17.9371 19.6352Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35934 9.83856C8.41653 9.3132 8.8515 8.91575 9.36927 8.91575H23.6308C24.1485 8.91575 24.5835 9.3132 24.6407 9.83856L24.9118 12.3301C25.4033 16.8465 25.4033 21.4046 24.9118 25.921L24.8851 26.1664C24.69 27.9591 23.3289 29.3887 21.5792 29.6388C18.2095 30.1204 14.7905 30.1204 11.4208 29.6388C9.67099 29.3887 8.31 27.9591 8.11488 26.1664L8.08819 25.921C7.59662 21.4046 7.59662 16.8465 8.08819 12.3301L8.35934 9.83856ZM10.2787 10.9905L10.108 12.5592C9.63303 16.9234 9.63303 21.3279 10.108 25.692L10.1347 25.9372C10.2272 26.7874 10.8727 27.4654 11.7026 27.5841C14.8853 28.0389 18.1147 28.0389 21.2973 27.5841C22.1273 27.4654 22.7728 26.7874 22.8653 25.9372L22.892 25.692C23.367 21.3279 23.367 16.9234 22.892 12.5592L22.7213 10.9905H10.2787Z" fill="#002D80"></path></svg></button></li></ul></div></td>
			</tr>`
		);
		jobTrackingTbodyDays = jobTracking.querySelectorAll(".job-tracking__day");
		vform.applyEvents($(jobTrackingTbodyDayForNewTask));

		initNewTask();
		calcTime();
	}

	jobTrackingAddTaskBtn.addEventListener("click", addTask);

	$(".job-tracking").on("click", ".job-tracking__day-toggle", function () {
		$(this).closest(".job-tracking__day").toggleClass("closed");
	})

	const calcTime = () => {
		jobTrackingTimeInputs = [...jobTracking.querySelectorAll(".job-tracking__time-input")];
		let jobTrackingTimeInputFilter = jobTrackingTimeInputs.filter(timeInput => timeInput.value)
		let jobTrackingTimeInputValue = jobTrackingTimeInputFilter.map(timeInput => timeInput.value);

		let jobTrackingMinsSummary = jobTrackingTimeInputValue.reduce((sumMins, timeInput) => {
			let time = timeInput;
			let hours = parseInt(time.split(":")[0]);
			let mins = parseInt(time.split(":")[1]);
			sumMins += hours * 60 + mins;
			return sumMins;
		}, 0)

		let jobTrackingHoursFinal = Math.floor(jobTrackingMinsSummary / 60)
		let jobTrackingMinsFinal = jobTrackingMinsSummary - jobTrackingHoursFinal * 60;

		if (jobTrackingHoursFinal < 10) {
			jobTrackingHoursFinal = "0" + jobTrackingHoursFinal;
		}
		if (jobTrackingMinsFinal < 10) {
			jobTrackingMinsFinal = "0" + jobTrackingMinsFinal;
		}

		jobTrackingTimeSummary.textContent = jobTrackingHoursFinal + ":" + jobTrackingMinsFinal;
	}

	if (jobTrackingTbodyDays.length > 0) {
		calcTime();
	}

	$(".job-tracking").on("change", ".job-tracking__time-input", calcTime)
}

